<template>
  <footer class="theFooter">
    <div class="container container--sm">
      <div class="theFooter__wrapper">
        <div>
          <p class="h3">{{ translation('footer_nav_section-about') }}</p>
          <NavigationList :label="'Secondary'">
            <NavigationListItem
                :url="'https://goodcallcze.sharepoint.com/:f:/s/GoodCallPraha/EjEB4rTpgsBNoSj0wf7zL8wBfgXu07qzlhTRmkQcmhypig?e=54FbKa'"
                :openInNewWindow="true"
            >
              {{ translation('footer_nav_link-about') }}
            </NavigationListItem>
            <NavigationListItem
                :url="'https://goodcallcze.sharepoint.com/:f:/s/GoodCallAll/Es-bRqQUDa5JnHjeTfUWWFMB88xZckslQQT_FhkiB5xGtw?e=9WXJsU'"
                :openInNewWindow="true"
            >
              {{ translation('footer_nav_link-articleList') }}
            </NavigationListItem>
          </NavigationList>
        </div>
        <div>
          <p class="h3">{{ translation('footer_nav_section-contact') }}</p>

          <NavigationList :label="'Contacts'">
            <NavigationListItem
                :url="'mailto:peoplecare@goodcall.eu'"
                :title="'E-mail'"
                :openInNewWindow="true"
            >
              peoplecare@goodcall.eu
            </NavigationListItem>
            <NavigationListItem
                :url="'mailto:development@goodcall.eu'"
                :title="'E-mail'"
                :openInNewWindow="true"
            >
              development@goodcall.eu
            </NavigationListItem>
          </NavigationList>
        </div>
      </div>

      <div class="theFooter__brands">
        <a href="/">
          <img
              src="../assets/images/goodtoknow_white.svg"
              alt="Goodcall"
              class="icon theFooter__brands-goodcall"
              width="97"
              height="30"
              loading="lazy"
          >
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
import NavigationListItem from "@/components/NavigationListItem";
import NavigationList from "@/components/NavigationList";
import codeBooksMixin from "@/mixins/codeBooksMixin";

export default {
  components: {NavigationList, NavigationListItem},
  mixins: [codeBooksMixin]
}
</script>